import axios from '@/allotment/axios'

export default {
  getLuxpowertek: id => axios.get(`/pcInv/config/${id}`), //获取鹏程配置属性
  postLuxpowertekTime: data => axios.post('/pcInv/write/time', data), //逆变器填写时间区间设置
  postLuxpowertekModel: data => axios.post('/pcInv/write/model', data), //逆变器填写模型设置
  postLuxpowertekWrite: data => axios.post('/pcInv/write', data), //逆变器填写参数设置
  postLuxpowertekReset: data => axios.post('/pcInv/reset', data), //逆变器重置参数设置
  postLuxpowertekFunction: data => axios.post('/pcInv/function/control', data), //逆变器功能参数设置
  postLuxpowertekParam: data => axios.post('/pcInv/bit/param/control', data), //逆变器位参数设置
  getIntelessConfig: id => axios.get(`/srInv/config/${id}`), //朔日-获取采集器配置信息
  postIntelessConfig: data => axios.post('/srInv/update/config', data), //朔日-修改采集器配置信息
  getIntelessSosenConfig: id => axios.get(`inv/sosen/config/${id}`), //松盛-获取采集器配置信息
  postIntelessSosenConfig: data => axios.post('/inv/sosen/save/config', data) //松盛-修改采集器配置信息
}
